import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux';
import {
	CRow,
	CCol,
	CCardHeader,
	CCard,
	CCardBody,
	CCardFooter,
	CTooltip,
	CLink,
	CForm,CFormInput,CFormTextarea,CFormSelect,
	CBadge,
	CDropdown,CDropdownToggle,CDropdownMenu,CDropdownItem,CDropdownDivider,
} from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { isMobile } from "react-device-detect";
import { 
	MyPage500,
	MyPagination,
	MyDialogform,
} from '../components/index';
import { UFunc } from "../helpers/functions";
import { Konfirm } from '../helpers/onConfirm';

const pjson     = require('../../package.json');
const Customer 	= (props) => {
	const uComponentname 	= Customer.name;
	const { 
		setLoading, showToast, prosesExpired, setSessionaktif
	} = props; 

	let uFuncname;//-->hanya untuk API
	const uNavigate  	= useNavigate();
	const uDispatch		= useDispatch();
	const uBahasaObj  	= useSelector(state => state.listBahasa);
	const uActiveroute  = useSelector(state => state.activeRoute);
	const uHTMLstyleTabel=useSelector(state => state.gHTMLstyleLaporan);
	const uTokenObj		= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsScrollBottom= useSelector(state => state.gIsScrollBottom);
	const uEfekapp		= useSelector(state => state.effectApp);
	const [uEfekview,setEfekview] = React.useState(false);

	//---VAR_GLOBALS--/
	const uSettingObj 	= useSelector(state => state.gListUserSetting);
	const uMaxData		= isMobile ? 50 : 100;
	const [uHTMLError500,setHTMLError500]	= React.useState(null);

	const uKeywordObj		= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uIsAllowedhapus	= uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN"
	const uHeaderActionObj  = useSelector(state => state.gInitHeaderAction);
	const uHandelView 		= uHeaderActionObj.isHeaderView || false;
	const uHandelTambah 	= uHeaderActionObj.isHeaderTambah || false;

	const [uDatamainArr,setDatamainArr]				= React.useState([]);
	const [uPageActive,setPageActive]		= React.useState(1);
	const [uJmlData,setJmlData] 			= React.useState(0);
	const [uJmlHal,setJmlHal] 				= React.useState(1);
	const [uTabelRowSelect,setTabelRowSelect]= React.useState(-1);
	const [uTabelIDPilih,setTabelIDPilih]	= React.useState(0);

	//--DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false);
	const [uDlgformdataObj,setDlgformdataObj]= React.useState({});
	//--END DLG_FORM--/

	const [ElBtnSimpan,setElBtnSimpan]		= React.useState(document.getElementById("btnDialogSimpan"));
	const uElJmldata	= document.getElementById("idjmldata");
	//---END VAR_GLOBALS--/

	//console.log("("+uComponentname+") uHeaderActionObj.isHeaderView: "+uHeaderActionObj.isHeaderView);
	//console.log("("+uComponentname+") uHandelView: "+uHandelView);

	const [uTimeElapsed,setTimeElapsed]		= React.useState(0);

	//---HANDLE--/
	const hdlToggleForm = () => { setDlgformshow(false); }
	const hdlLastFieldKDown = (_EV)=>{
		if(_EV.which === 13) {
			if (_EV.ctrlKey && _EV.target.nodeName === "TEXTAREA") {
				_EV.preventDefault();
				_EV.stopPropagation();
				var content = _EV.target.value;
				var start   = _EV.target.selectionStart;
				var substr1 = content.slice(0, start);
				var substr2 = content.slice(_EV.target.selectionEnd);
				//alert(_EV.target.selectionEnd);
				_EV.target.value  = substr1 + '\n' + substr2;
				return;
			}

			_EV.preventDefault();
			ElBtnSimpan.focus();
		}
	}
	const hdlKlikSimpan = () => {
		//--VALIDASI_SIMPAN--/
		let vElfocus = document.getElementById("inpcustomernama");
		if((uDlgformdataObj.nama_customer||"").trim().length < 3) {
			vElfocus && vElfocus.focus();
			showToast((uBahasaObj.caption_namacustomer||"caption_namacustomer")+" "+(uBahasaObj.caption_invalid||"caption_invalid")+".."); 
			return;
		}
		vElfocus = document.getElementById("inpkeyword");
		if((uDlgformdataObj.keyword_customer||"").trim() !== "")
			if(uDlgformdataObj.keyword_customer .trim().length < 3) {
				vElfocus && vElfocus.focus();
				showToast((uBahasaObj.word_keyword||"Keyword")+" "+(uBahasaObj.caption_invalid||"caption_invalid")+".."); 
				return;
			}
		vElfocus = document.getElementById("inptelphp");
		if((uDlgformdataObj.telp_hp||"").trim() !== "")
			if(uDlgformdataObj.telp_hp.trim().length < 3) {
				vElfocus && vElfocus.focus();
				showToast((uBahasaObj.caption_telphp||"Telp/HP")+" "+(uBahasaObj.caption_invalid||"caption_invalid")+".."); 
				return;
			}
		vElfocus = document.getElementById("inpalamat");
		if((uDlgformdataObj.alamat||"").trim() !== "")
			if(uDlgformdataObj.alamat.trim().length < 3) {
				vElfocus && vElfocus.focus();
				showToast((uBahasaObj.word_alamat||"Alamat")+" "+(uBahasaObj.caption_invalid||"caption_invalid")+".."); 
				return;
			}
		//--END VALIDASI_SIMPAN--/

		apiProsessimpan();
	}
	const hdlKlikEdit = (_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL) || 0; if(_IDTABEL <= 0) return;

		setTabelIDPilih(_IDTABEL);
		var vObjdx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);

		setDlgformdataObj({
			nama_customer: (uDatamainArr[vObjdx].nama),
			keyword_customer: (uDatamainArr[vObjdx].keyword||""),
			tipe_tagihan: (uDatamainArr[vObjdx].tipe_tagihan||"LANGSUNG"),
			telp_hp: (uDatamainArr[vObjdx].telp_hp||""),
			alamat: (uDatamainArr[vObjdx].alamat||""),
			dlg_header: (uBahasaObj.caption_editdata||"caption_editdata")+": "+
				(uDatamainArr[vObjdx].nama || "").toUpperCase(),
		})
		//---END INIT_FORM_EDIT--/

		setDlgformshow(true);
	}
	const hdlKlikHapus = async(_IDTABEL) => {
		_IDTABEL = parseInt(_IDTABEL) || 0;
		if(_IDTABEL <= 0) return;

		var vObjdx	= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);
		var vRowIdx	= UFunc.getTabelRowIndeks("idtabeldata","idtr"+_IDTABEL);
		setTabelRowSelect(vRowIdx);

		const vConfirm	= 
			(uBahasaObj.caption_hapusdata||"caption_hapusdata")+": <B>"+uDatamainArr[vObjdx].nama.toUpperCase()+"</B>"+
			"<BR>"+(uBahasaObj.petunjuk_hapus||"petunjuk_hapus")+
			"<BR><BR><B>"+(uBahasaObj.confirm_hapus||"confirm_hapus")+"</B>"+
		"";

		if(await Konfirm(vConfirm)) apiProseshapus(_IDTABEL);
	}
	//---END HANDLE--/

	//---Init_LOAD--/
	const initFormAwal = () => {
		setTabelIDPilih(0);
		setDlgformdataObj({});
	}
	//---END Init_LOAD--/

	const contentMain = () => {
		if(uHTMLError500) return "";

		const vMin			= (uPageActive-1)*uMaxData;
		const vMax			= (vMin+uMaxData);
		let vNumber			= (vMin);
		const vKeyword 		= UFunc.filterRegex(uKeywordObj.kwd_customer || "");
		const vKeywordcolor = uSettingObj.color_keyword;
		const vReplace 		= new RegExp(vKeyword,"ig");

		const vDataViewObj	= uDatamainArr.slice(vMin,(vMax));

		return (
		<table className="table table-borderless table-striped table-hover" id="idtabeldata">
		<thead>
			<tr className="d-none d-md-table-row text-center align-top classfontsmaller">
			<th width="5%" className="px-1">No</th>
			<th className="px-1">
				<CRow className="mx-0">
				<CCol md="3" className="text-start">{uBahasaObj.caption_namacustomer||"caption_namacustomer"}</CCol>
				<CCol md="2" className="text-center">{uBahasaObj.caption_telphp||"caption_telphp"}</CCol>
				<CCol md="4" className="text-start">{uBahasaObj.word_keterangan||"word_keterangan"}</CCol>
				<CCol md="2" className="text-center">{uBahasaObj.word_penagihan||"Penagihan"}</CCol>
				<CCol md="1">&middot;</CCol>
				</CRow>
			</th>
			</tr>
			<tr className="d-md-none classfontsmaller">
			<th width={30} className="p-0"/>
			<th className="p-0"/>
			</tr>
		</thead>

		<tbody>
		{vDataViewObj.map((vItems,vKeys)=>{
			const {
				id,telp_hp,kode,nama,alamat,keyword,tipe_tagihan,
			} = vItems;

			vNumber++;
			const vCaptionUpper	= (nama||"").toUpperCase();

			const vCustomernama	= vKeyword==="" ? (kode+" &middot; "+nama) 
				: (kode+" &middot; "+nama).replace(vReplace,"<b><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vTelphp= vKeyword==="" ? (telp_hp||"-") 
				: (telp_hp||"-").replace(vReplace,"<b><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vAlamat= vKeyword==="" ? (alamat||"") 
				: (alamat||"").replace(vReplace,"<b><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
			const vKeywordcaption = vKeyword==="" ? (keyword||"") 
				: (keyword||"").replace(vReplace,"<b><U style='color:"+vKeywordcolor+"'>"+vKeyword.toUpperCase()+"</U></b>");
				
			return (
			<tr id={"idtr"+id} key={vKeys} className={"align-top text-end"+(uTabelRowSelect===vKeys?" classrowselect":"")}>
			<td align="right" className="px-1 pe-0">{vNumber}.</td>
			<td className="px-1">
			<CRow className="mx-0">
				<CCol md="3" className="px-1 d-flex justify-content-between text-start">
					<div className="text-info">{UFunc.renderHTML(vCustomernama)}</div>

					<CDropdown autoclose={true} className="d-md-none">
					<CDropdownToggle color="transparent" className="p-0 m-0" 
						caret={false}>
						<CIcon icon="cilOptions" className="classikoncoreui" height={25}/>
					</CDropdownToggle>
					<CDropdownMenu>
						<CDropdownItem 
							onClick={()=>hdlKlikEdit(id)}>
							<CIcon className="classikonedit me-2 align-middle" height={25}/>
							<span>{uBahasaObj.caption_editdata}</span>
						</CDropdownItem>
						
						{uIsAllowedhapus && (
						<>
						<CDropdownDivider/>
						<CDropdownItem 
							onClick={()=>hdlKlikHapus(id)}>
							<CIcon className="classikonhapus me-2 align-middle" height={25}/>
							<span>{uBahasaObj.caption_hapusdata}</span>
						</CDropdownItem>
						</>
						)}
					</CDropdownMenu>
					</CDropdown>
				</CCol>

				<CCol xs="12" className="my-3 d-md-none classborderbottom"/>

				<CCol xs="4" className="px-1 text-start d-md-none">{uBahasaObj.caption_telphp}</CCol>
				<CCol xs="8" md="2" className="px-1 text-md-center">
					<small className="fw-bolder">{UFunc.renderHTML(vTelphp.toUpperCase())}</small>
				</CCol>

				<CCol xs="3" className="px-1 text-start d-md-none">{uBahasaObj.word_alamat}</CCol>
				<CCol xs="9" md="4" className="px-1 text-md-start">
				{((keyword||"")==="" && (alamat||"")==="") ? ("-") : (
				<>
					{(keyword||"")!=="" && (
					<div className="d-none d-md-block">&middot; {UFunc.renderHTML(vKeywordcaption)} &middot;</div>
					)}
					<small className="fst-italic">{UFunc.renderHTML(vAlamat)}</small>
				</>
				)}
				</CCol>

				<CCol xs="5" className="px-1 text-start d-md-none">{uBahasaObj.word_penagihan || "Penagihan"}</CCol>
				<CCol xs="7" md="2" className="px-1 text-md-center">
					<small className={(tipe_tagihan||"LANGSUNG")!=="LANGSUNG" ? "text-primary fst-italic" : ""}>
						{tipe_tagihan || "LANGSUNG"}
					</small>
				</CCol>

				{(keyword||"")!=="" && (
				<>
				<CCol xs="4" className="px-1 text-start d-md-none">{uBahasaObj.word_keyword}</CCol>
				<CCol xs="8" className="px-1 d-md-none">{UFunc.renderHTML(vKeywordcaption)}</CCol>
				</>
				)}

				<CCol md="1" className="px-0 text-md-center d-none d-md-block">
					<CTooltip content={"--"+(uBahasaObj.caption_editdata || "caption_editdata")+": "+vCaptionUpper}>
					<CLink onClick={()=>hdlKlikEdit(id)} className="classikontabel classikonedit classcursorpointer mx-0"/>
					</CTooltip>

					{uIsAllowedhapus && (
					<>
						<CTooltip content={"--"+(uBahasaObj.caption_hapusdata||"caption_hapusdata")+": "+vCaptionUpper}>
						<CLink 
							className={"classcursorpointer classikontabel classikonhapus mx-0"}
							onClick={()=>hdlKlikHapus(id)} />
						</CTooltip>
					</>
					)}
				</CCol>
			</CRow>
			</td>
			</tr>
			)
		})}
		</tbody>
		</table>
		)//>
	}
	const contentDlgform = () => {
		if(!uISDlgformshow) return (<></>)//>

		return (
			<>
			<CForm className="mx-auto mx-lg-5">
			<CRow className="my-2">
				<CCol md="5" lg="4" className="text-md-end fw-bolder">
					{uBahasaObj.caption_namacustomer||"caption_namacustomer"}
				</CCol>
				<CCol>
					<CFormInput maxLength={100}
						type="text"
						size="sm"
						className="form-control"
						value={uDlgformdataObj.nama_customer||""}
						onChange={(e) => setDlgformdataObj({...uDlgformdataObj,nama_customer:(e.target.value)})}
						id="inpcustomernama"/>
				</CCol>
			</CRow>

			<CRow className="my-2">
				<CCol md="5" lg="4" className="text-md-end">
					{uBahasaObj.word_keyword||"keyword"}
				</CCol>
				<CCol>
				<CFormInput maxLength={100}
					size="sm"
					className="text-capitalize"
					value={uDlgformdataObj.keyword_customer||""}
					onChange={(e) => setDlgformdataObj({...uDlgformdataObj,keyword_customer:(e.target.value)})}
					id="inpkeyword"/>
				</CCol>
			</CRow>

			<CRow className="my-2">
				<CCol md="5" lg="4" className="text-md-end">
					{uBahasaObj.caption_tipepenadihan||"Tipe Penagihan"}
				</CCol>
				<CCol>
					<CFormSelect size="sm"
						onChange={(e) => setDlgformdataObj({...uDlgformdataObj,tipe_tagihan:(e.target.value)})}
						id="inptipepenagihan">
					<option value='LANGSUNG'>PENAGIHAN LANGSUNG</option>
					<option value='BULANAN'>TAGIHAN TIAP BULAN</option>
					</CFormSelect>
				</CCol>
			</CRow>


			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
				<CCol md="5" lg="4" className="text-md-end">
					{uBahasaObj.caption_telphp||"caption_telphp"}
				</CCol>
				<CCol>
				<CFormInput maxLength={50}
					size="sm"
					className="form-control text-uppercase"
					value={uDlgformdataObj.telp_hp||""}
					onChange={(e) => setDlgformdataObj({...uDlgformdataObj,telp_hp:(e.target.value)})}
					id="inptelphp" />
				</CCol>
			</CRow>

			<CRow className="my-2">
				<CCol md="5" lg="4" className="text-md-end">
					{uBahasaObj.word_alamat||"word_alamat"}
				</CCol>
				<CCol>
					<CFormTextarea
						size="sm"
						className="form-control"
						value={UFunc.br2nl(uDlgformdataObj.alamat||"")}
						onChange={(e) => setDlgformdataObj({...uDlgformdataObj,alamat:UFunc.nl2br(e.target.value)})}
						onKeyDown={(e) => hdlLastFieldKDown(e)}
						id="inpalamat" />
					<div className="classpetunjuk">*) {uBahasaObj.petunjuk_textarea||"petunjuk_textarea"}</div>
				</CCol>
			</CRow>
			</CForm>
			</>
		)//>
	}

	//---API_FUNC--/
	const apiLoaddata = () => {
		uFuncname = apiLoaddata.name;
		setHTMLError500();

		setJmlData(0);
		setDatamainArr([]);
		setTabelIDPilih(0);
		setTabelRowSelect(-1);
		setPageActive(1);

		/*//--TESTING_FRONTEND--/
		return;
		//--END TESTING_FRONTEND--*/

		const vKeyword = uKeywordObj.kwd_customer || "";
		const vDATAS	= JSON.stringify({
			send_keyword : vKeyword,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_customer/ld_data";

		setTimeElapsed(0);
		const vTimeBegin = new Date();
		setLoading(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			//console.log("("+uComponentname+"-"+uFuncname+") output_string : "+JSON.stringify(output_string.errors));
			if(output_string.tampil) {
				setDatamainArr(JSON.parse(output_string.dataobject||"[]"));

				const vTimeEnd = new Date();
				const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
				setTimeElapsed(vTimeDiff);
			} else if(output_string.info) {
				setHTMLError500(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHTMLError500("<font color='red'>"+vMsg+"</font>");
			} else if(output_string.expired) {
				prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			setHTMLError500(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiProsessimpan = () => {
		uFuncname = apiProsessimpan.name;

		/*//--TESTING_FRONTEND--//
		return;
		//--END TESTING_FRONTEND--//*/

		const vDATAS	= JSON.stringify({
			send_tabelid : uTabelIDPilih,
			send_customernama : uDlgformdataObj.nama_customer,
			send_keyword : uDlgformdataObj.keyword_customer,
			send_telphp : uDlgformdataObj.telp_hp,
			send_alamat : uDlgformdataObj.alamat,
			send_tipetagihan : uDlgformdataObj.tipe_tagihan,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_customer/pr_simpan";

		setLoading(true);
		ElBtnSimpan.disabled = true;
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);
			ElBtnSimpan.disabled = false;

			if(output_string.sukses) {
				if(uTabelIDPilih <= 0) {
					const vTmpObject	= {
						id 		: output_string.tabelid || "255",
						kode 	: UFunc.leadZero((output_string.tabelid || "255"),5),
						keyword : (uDlgformdataObj.keyword_customer ||"").trim(),
						telp_hp : (uDlgformdataObj.telp_hp||"").trim(),
						tipe_tagihan : (uDlgformdataObj.tipe_tagihan||"").trim(),
						nama 	: UFunc.capitalize((uDlgformdataObj.nama_customer||"").trim()),
						alamat 	: UFunc.nl2br(UFunc.capitalize((uDlgformdataObj.alamat||"").trim())),
					}
					setDatamainArr([vTmpObject,...uDatamainArr]);
					setJmlData((uJmlData+1));
					setDlgformdataObj({dlg_header:uDlgformdataObj.dlg_header});
				} else {
					const vObjdx				= UFunc.getObjectIndeks(uDatamainArr,uTabelIDPilih);
					uDatamainArr[vObjdx].nama 	= UFunc.capitalize(uDlgformdataObj.nama_customer.trim());
					uDatamainArr[vObjdx].keyword = UFunc.capitalize(uDlgformdataObj.keyword_customer .trim());
					uDatamainArr[vObjdx].telp_hp = (uDlgformdataObj.telp_hp||"").trim();
					uDatamainArr[vObjdx].tipe_tagihan = (uDlgformdataObj.tipe_tagihan||"").trim();
					uDatamainArr[vObjdx].alamat 	= UFunc.nl2br(UFunc.capitalize((uDlgformdataObj.alamat||"").trim()));

					hdlToggleForm(); 
					return;
				}

				setTabelRowSelect(-1);
				setPageActive(1);
				showToast((uBahasaObj.pesan_sukses || "pesan_sukses"),"SUKSES");
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				ElBtnSimpan.disabled = true;
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			ElBtnSimpan.disabled = false;
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProseshapus = (_IDTABEL) => {
		uFuncname 	= apiProseshapus.name;
		_IDTABEL = parseInt(_IDTABEL) || 0;
		const vObjdx= UFunc.getObjectIndeks(uDatamainArr,_IDTABEL);

		/*//---TESTING_FRONTEND--/
		console.log("("+uComponentname+"-"+uFuncname+") uTabelIDPilih : "+uTabelIDPilih);
		return;
		//---END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tabelid : _IDTABEL,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_customer/pr_hapus";

		setLoading(true);
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json();} })
		.then((output_string) => {
			setSessionaktif(true);
			setLoading(false);

			if(output_string.sukses) {
				uDatamainArr.splice(vObjdx,1);
				setTabelRowSelect(-1);
				setJmlData((parseInt(uDatamainArr.length)||0));
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("("+uComponentname+"-"+uFuncname+") output_string.errors : "+output_string.errors);
				var vMsg;
				if(pjson.mydefault.environment==="development")
					vMsg = output_string.errors;
				else
					vMsg = pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true);
				prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("("+uComponentname+"-"+uFuncname+") catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END API_FUNC--/

	//---EFFECT--/
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});
		uDispatch({type: "set", gUrlbefore: window.location.pathname + window.location.search});

		apiLoaddata();

		return () => { 
			uDispatch({type: "set", gInitHeaderAction: {}});
			setDlgformshow(false);
			setDatamainArr([]);
		}
	},[]);
	React.useEffect(()=>{
		setJmlData(uDatamainArr.length);
	},[uDatamainArr,uDatamainArr.length]);
	React.useEffect(()=>{
		let vJmlHal	= Math.ceil(uJmlData / uMaxData);
		setJmlHal(vJmlHal); setPageActive(uPageActive<=0?1:uPageActive);

		const vKeyword = uKeywordObj.kwd_customer || "";
		if (vKeyword.length < 3) {
			uElJmldata && (uElJmldata.innerHTML = "&#8734;");
			return;
		}
		uElJmldata && (uElJmldata.innerHTML = UFunc.formatAngka(uJmlData));
	},[uJmlData]);
	React.useEffect(()=>{
		if(!uHandelView) return;
		apiLoaddata();

		uHeaderActionObj.isHeaderView = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});
	},[uHandelView]);
	React.useEffect(()=>{
		if(!uHandelTambah) return;

		uHeaderActionObj.isHeaderTambah = false;
		uDispatch({type: "set", gInitHeaderAction: uHeaderActionObj});

		if(uHTMLError500) return;

		setDlgformdataObj({
			nama_customer:"",
			keyword_customer:"",
			telp_hp:"",
			tipe_tagihan:"LANGSUNG",
			dlg_header: (uBahasaObj.word_tambah||"word_tambah")+" "+uBahasaObj["menus_"+uActiveroute.toLowerCase()],
		});

		setDlgformshow(true);
	},[uHandelTambah]);
	React.useEffect(()=>{
		if(!uISDlgformshow) { initFormAwal(); return; }

		let vTimeout = setTimeout(() => {
			clearTimeout(vTimeout);
			setElBtnSimpan(document.getElementById("btnDialogSimpan"));

			if(!isMobile) {
				const vElFocus = document.getElementById("inpcustomernama");
				vElFocus && vElFocus.focus();
			}
		},350);
	},[uISDlgformshow]);
	React.useEffect(()=>{ setTabelRowSelect(-1); },[uPageActive]);//-->Unselect_ROW
	//---END EFFECT--/

	//console.log("("+uComponentname+") Checked..");
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }
	if(uHTMLError500) return (<MyPage500 content={uHTMLError500} {...props}/>);

	return (
		<>
		<CCard className="classcardbg">
			<CCardHeader className="d-flex justify-content-between align-items-center">
			<small className="text-primary fw-bolder">
				<span className="d-md-none">
				{(()=>{
					const vKeyword = uKeywordObj.kwd_customer || "";
					if(vKeyword.length < 3) {
						return (<>&#8734;</>)
					}

					return "("+UFunc.formatAngka(uJmlData)+")"
				})()}
				</span>
			</small>
			<small className="text-muted classfontsmaller">{UFunc.formatAngka(uTimeElapsed)}ms</small>
			</CCardHeader>

			<CCardBody className="px-0">{contentMain()}</CCardBody>

			{(uJmlData > uMaxData) && (
			<CCardFooter>
				<MyPagination
					activePage={uPageActive}
					pages={uJmlHal}
					onActivePageChange={(i) => setPageActive(i)}
				></MyPagination>
			</CCardFooter>
			)}
		</CCard>

		<MyDialogform
			options={{size:"lg",centered:false}}
			onSimpan={()=>hdlKlikSimpan()}
			show={uISDlgformshow} 
			dialogHeader={uDlgformdataObj.dlg_header ||"" }
			toggle={hdlToggleForm}
			renderContent={contentDlgform()}/>
		</>
	)//>
}
	
export default Customer;
